import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ModemRouterSimcard = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M6.665 10.309h2.667a.333.333 0 0 1 .333.333v2.333a.333.333 0 0 1-.333.334H6.665a.333.333 0 0 1-.333-.334v-2.333a.333.333 0 0 1 .333-.333ZM9 10.975h-2v1.667h2v-1.667Z" />
      <path d="M9.976 14.414H6.023a.9.9 0 0 1-.898-.898V8.433a.9.9 0 0 1 .898-.898h3.106c.088 0 .173.035.236.098l1.412 1.412a.333.333 0 0 1 .097.235v4.236a.9.9 0 0 1-.898.898ZM6.023 8.202a.233.233 0 0 0-.231.231v5.083a.233.233 0 0 0 .231.23h3.953a.233.233 0 0 0 .232-.23V9.418L8.992 8.202H6.023ZM11.332 4.974a.333.333 0 0 1-.333-.333v-3h-6v3a.333.333 0 1 1-.667 0V1.308a.333.333 0 0 1 .333-.333h6.667a.333.333 0 0 1 .333.333V4.64a.333.333 0 0 1-.333.333Z" />
      <path d="M6.665 4.64a.333.333 0 0 1-.333-.333V2.974a.333.333 0 0 1 .667 0v1.333a.333.333 0 0 1-.334.334ZM9.333 4.64A.333.333 0 0 1 9 4.308V2.974a.333.333 0 0 1 .667 0v1.333a.333.333 0 0 1-.334.334ZM3 5.975h10a.333.333 0 0 1 .332.333v8.333a1.669 1.669 0 0 1-1.666 1.667H4.333a1.669 1.669 0 0 1-1.667-1.667V6.308a.333.333 0 0 1 .333-.333Zm9.666.666H3.333v8a1 1 0 0 0 1 1h7.333a1 1 0 0 0 1-1v-8Z" />
    </svg>
  );
};

ModemRouterSimcard.category = 'product-category';

ModemRouterSimcard.displayName = 'ModemRouterSimcard';
